<template lang="pug">
div(v-if="hasItemsToDisplay")
  .mb-3.round-xl(:class="cardClasses")
    .d-flex.align-center.clickable(:class="{ 'px-4 py-2 neutral300 border-selected-top':isSelected }" @click="onToggleSelection")
      .flex-grow-1
        .d-flex
          v-icon.mr-2(color="success" size="small") mdi-circle
          span.text-md.font-semibold {{ getTitle }}
      v-icon(v-if="isSelected") $yzi-chevron-up
      v-icon(v-else) $yzi-chevron-down
    .white.px-4.py-2(v-if="isSelected" :class="{ 'border-selected-bottom':isSelected }")
      v-row(v-for="activeMed in parentActiveMedications" :key="activeMed.id" align="center" no-gutters)
        v-col
          .text-sm {{ activeMed.medication.name }}
        v-spacer
        v-col
          .d-flex.justify-end.align-center
            v-btn.button-sm.neutral700--text.px-0.underline(text @click="handleMarkAsInactive(activeMed)") Mark as inactive
  .dialogs
    mark-as-inactive-dialog(v-if="openMarkAsInactiveDialog" :open.sync="openMarkAsInactiveDialog" :parentMedication="selectedMedication" @close="selectedMedication = null" @updated="$emit('updated')")
</template>

<script>
import MarkAsInactiveDialog from '@/components/clinic/dialogs/MarkAsInactiveDialog.vue'

export default {
  components: {
    MarkAsInactiveDialog,
  },
  props: {
    parentActiveMedications: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      isSelected: false,
      open: true,
      openMarkAsInactiveDialog: false,
      selectedMedication: null,
    }
  },
  computed: {
    hasItemsToDisplay() {
      return this.parentActiveMedications?.length > 0
    },
    cardClasses() {
      return this.isSelected ? 'border-selected' : 'px-4 py-2 neutral300' 
    },
    getTitle () {
      return `${this.parentActiveMedications.length} active medicine`
    }
  },
  methods: {
    onToggleSelection() {
      this.isSelected = !this.isSelected
    },
    handleMarkAsInactive(item) {
      this.selectedMedication = item
      this.openMarkAsInactiveDialog = true
    }
  },
}
</script>

<style lang="scss" scoped>
.border-selected {
  border: 1px solid #C1C1C1 !important;
}
.border-selected-top {
  border-radius: 10px 10px 0px 0px;
}
.border-selected-bottom {
  border-radius: 0px 0px 10px 10px;
}
</style>